import { useEffect } from 'react'
import { useUIStore } from '../../stores/uiStore'
import { XMarkIcon, CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'

/**
 * Toast Component
 * Global toast notification
 */
export default function Toast() {
  const { toast, hideToast } = useUIStore()

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        hideToast()
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [toast, hideToast])

  if (!toast) return null

  const variants = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-800',
      icon: CheckCircleIcon,
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      text: 'text-red-800',
      icon: ExclamationCircleIcon,
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-800',
      icon: InformationCircleIcon,
    },
  }

  const variant = variants[toast.type] || variants.info
  const Icon = variant.icon

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in">
      <div className={`${variant.bg} ${variant.border} ${variant.text} border rounded-lg shadow-lg p-4 max-w-md flex items-start gap-3`}>
        <Icon className="h-5 w-5 flex-shrink-0 mt-0.5" />
        <p className="flex-1 text-sm font-medium">{toast.message}</p>
        <button
          onClick={hideToast}
          className="flex-shrink-0 hover:opacity-70 transition-opacity"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  )
}